<template>
    <section id="app-header-mobile" class="uk-section uk-padding-remove uk-hidden@s">
        <nav class="uk-child-width-1-1" uk-grid>
            <div class="uk-text-center">
                <router-link class="uk-navbar-item uk-logo" :to="{ name: 'Start' }">
                    <img src="https://schoolphotos.ams3.digitaloceanspaces.com/assets/logo/lrp-logo.png" alt="School Photos by Landon Road Photographers" width="300"/>
                </router-link>
            </div>

            <div v-if="proofcard != ''" class="uk-text-center">
                    <span v-for="page in pages" :key="page.name" ><router-link class="uk-button uk-button-default uk-button-small" :to="{ name: `${page.name}` }" >{{ page.title }} </router-link></span>
            </div>
        </nav>
    </section>

    <section id="app-header" class="uk-section uk-padding-remove uk-visible@s">
        <nav class="uk-navbar-container" uk-navbar>
            <div class="uk-navbar-Left">
                <router-link class="uk-navbar-item uk-logo" :to="{ name: 'Start' }">
                    <img src="https://schoolphotos.ams3.digitaloceanspaces.com/assets/logo/lrp-logo.png" alt="School Photos by Landon Road Photographers" width="300"/>
                </router-link>
            </div>

            <div v-if="proofcard != ''" class="uk-navbar-right">
                <ul class="uk-navbar-nav">
                    <li v-for="page in pages" :key="page.name" ><router-link class="uk-button uk-button-default uk-button-small" :to="{ name: `${page.name}` }" >{{ page.title }} </router-link></li>
                </ul>
            </div>
        </nav>
    </section>
</template>

<script>
import { mapGetters } from "vuex"

export default {
    data() {
        return {
            pages: [
                { name: 'Start',    title: "Photocard" },
                { name: 'Products', title: "Products" },
                { name: 'Checkout', title: "Checkout" },
            ],
        }
    },
    computed: {
        ...mapGetters ({
            proofcard: 'proofcard',
        }),
    },
};
</script>

<style></style>
